module.exports = __webpack_public_path__ + "static/media/antra.bcecbb23.jpg";